module.exports = __webpack_public_path__ + "img/a perfect day for errands.86ca3a4b.png";